import React from 'react';
import { CheckIcon } from 'lucide-react';
import { HERO_IMAGE, OFFER_ANCHOR } from '../data/electrical';
const INCLUDES = ['Visual diagnostic maps', 'Troubleshooting flowcharts', 'Symptom-based pathways', 'Testing sequences', 'Circuit & component references', 'Measurement resources', 'Professional field-ready tools'];
export function SystemSection() {
  return <section className="bg-white px-4 py-4 sm:py-6" data-id="element-179" data-mp="31kgwx21o8937">
      <div className="mx-auto max-w-4xl" data-id="element-180" data-mp="31ma4cjk3yxc9">
        <h2 className="text-center text-lg leading-tight text-navy sm:text-3xl" data-id="element-181" data-mp="2wu8x5c1srwt3">
          THE COMPLETE 6-IN-1 VISUAL DIAGNOSTIC SYSTEM
        </h2>

        <div className="mt-2 grid items-center gap-3 sm:grid-cols-2" data-id="element-182" data-mp="2ssx3mvfsyrfm">
          <a href={OFFER_ANCHOR} className="block" data-id="element-183" data-mp="2nu3pd0soywee">
            <img src={HERO_IMAGE} alt="The complete ELECTRICAL DIAGNOSTIC PRO™ system: 6 modules and 4 bonuses" loading="lazy" className="mx-auto w-full max-w-sm" data-id="element-184" data-mp="2nr7tdi0emhsl" />
          </a>

          <div data-id="element-185" data-mp="13yy57f7yg3h2">
            <p className="font-display text-xl uppercase leading-none text-navy sm:text-2xl" data-id="element-186" data-mp="13yg2bzqser06">
              ⚡ ELECTRICAL DIAGNOSTIC PRO™
            </p>
            <p className="mt-1 font-head text-[11px] font-bold uppercase tracking-wide text-navy/70 sm:text-sm" data-id="element-187" data-mp="u120p69iw6rx">
              READY-TO-USE VISUAL TROUBLESHOOTING FOR ELECTRICAL PROFESSIONALS
            </p>
            <p className="mt-1 text-[13px] font-semibold text-carbon/80" data-id="element-188" data-mp="1mpz648smy939">
              Diagnostics • Measurements • Circuits • Protection • Controls •
              Real Cases
            </p>
            <ul className="mt-1.5 grid gap-0.5" data-id="element-189" data-mp="1crs1mpfj9ji5">
              {INCLUDES.map(item => <li key={item} className="flex items-start gap-2 text-[13px] font-semibold text-carbon" data-id="element-190" data-mp="1hqmihltxwxzm">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-navy" aria-hidden="true" strokeWidth={3} data-id="element-191" data-mp="1atdh004qw6h" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}